import { apiInstance } from '.';
import { AxiosRequestConfig } from 'axios';

export const apiGET = async (
  url: string,
  config?: AxiosRequestConfig,
  data?: any
): Promise<any> => {
  if (data && config) {
    config.data = data;
  }
  const response: any = await apiInstance
    .get(url, config)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.log(error);
      // Request made and server responded
      if (error.response) {
        if (error.response.data) {
          return error.response.data;
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        return 'Error ' + error.message;
      }
    });
  return response;
};
